import {h, Component} from 'preact';

import Heading from './Heading';
import Nav from './Nav';
import NavItem from './NavItem';
import MegaMenu from './MegaMenu';
import {dropMenu} from '../styles';

class DropMenu extends Component {

    static heading = Heading;
    static nav = Nav;
    static navItem = NavItem;
    static megaMenu = MegaMenu;

    render( {menuId, title, className, style = {}, children} ) {
        return (
            <div id={menuId}
                 style={style}
                 className={[dropMenu.root, className].join( ' ' )}>
                {children}
            </div>
        )
    }
};

export default DropMenu;